import { ReactNode } from 'react';

export type StepConfig = {
  title: string;
  description?: ReactNode;
  component: ReactNode;
  skippable?: boolean;
  infoText: string;
  buttonLabel?: string;
};

export const STEP_FORM_ID = 'challenge-step-form';

export const DEFAULT_INFO_TEXT =
  'You will have the ability to edit all of this information before your challenge is live. The information input here is simply a starting point for creating your challenge.';
